const UPDATE_MY_INFO_ADDRESS_FORM = 'UPDATE_MY_INFO_ADDRESS_FORM';

export default UPDATE_MY_INFO_ADDRESS_FORM;
